import { useQuery } from "@tanstack/react-query";
import { getOfferAvatars } from "@/app/actions/client-avatar/get/action";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchOfferAvatars(options: { offerId?: number; enabled?: boolean } = {}) {
  const { offerId, enabled = true } = options;

  return useQuery({
    queryKey: [QueryKey.CLIENT_AVATAR, offerId],
    queryFn: () => getOfferAvatars(offerId!),
    enabled: enabled && !!offerId,
    staleTime: Infinity,
  });
}
